import { ArrowRight, MapPin } from "lucide-react";
import { SITE } from "../lib/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden bg-[#050505] flex items-end"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${SITE.media.heroBg})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" aria-hidden="true" />
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden="true" />

      {/* Side strip */}
      <div className="absolute left-0 top-0 h-full w-px bg-white/10 hidden md:block" aria-hidden="true" />
      <div className="absolute right-0 top-0 h-full w-px bg-white/10 hidden md:block" aria-hidden="true" />

      {/* Vertical caption */}
      <div className="hidden lg:flex absolute right-6 top-1/2 -translate-y-1/2 rotate-90 origin-right text-[10px] uppercase tracking-[0.5em] text-white/40">
        EST · Centreville VA · Print Shop
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pb-20 pt-32 md:pt-40 w-full">
        <div className="reveal reveal-delay-1 flex items-center gap-3 mb-8">
          <span className="h-px w-12 bg-[#FF2222]" />
          <span className="text-[11px] uppercase tracking-[0.3em] text-white/70 flex items-center gap-2">
            <MapPin size={12} className="text-[#FF2222]" /> {SITE.hero.eyebrow}
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="reveal reveal-delay-2 font-display uppercase text-white leading-[0.85] tracking-tighter text-[18vw] md:text-[14vw] lg:text-[10.5vw]"
        >
          {SITE.hero.line1}
          <br />
          <span className="text-[#FF2222]">/</span> {SITE.hero.line2}
        </h1>

        <p className="reveal reveal-delay-3 mt-8 max-w-xl text-base md:text-lg text-white/70 leading-relaxed">
          {SITE.hero.sub}
        </p>

        <div className="reveal reveal-delay-4 mt-10 flex flex-wrap items-center gap-4">
          <button
            data-testid="hero-cta-gallery"
            onClick={() => scrollTo("gallery")}
            className="group bg-[#FF2222] hover:bg-white hover:text-black text-white uppercase font-bold tracking-wider text-xs md:text-sm px-8 py-4 inline-flex items-center gap-3 transition-colors"
          >
            View Gallery <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-cta-contact"
            onClick={() => scrollTo("contact")}
            className="bg-transparent border border-white/40 hover:border-[#FF2222] hover:text-[#FF2222] text-white uppercase font-bold tracking-wider text-xs md:text-sm px-8 py-4 transition-colors"
          >
            Start a Custom Order
          </button>
        </div>
      </div>
    </section>
  );
};
